var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { ref: "modal", staticClass: "modal", class: [_vm.modalClass] }, [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c(
          "form",
          {
            staticClass: "modal-content",
            attrs: { disabled: _vm.disabled || _vm.applyDisabled },
            on: {
              submit: function($event) {
                $event.preventDefault()
                _vm.apply($event)
              }
            }
          },
          [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", {
                directives: [
                  {
                    name: "i18n",
                    rawName: "v-i18n",
                    value: _vm.title,
                    expression: "title"
                  }
                ],
                staticClass: "modal-title"
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", disabled: _vm.disabled },
                  on: { click: _vm.hide }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [_vm._t("default")], 2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _vm._t("modal-footer"),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-link",
                    attrs: { type: "button", disabled: _vm.disabled },
                    on: { click: _vm.hide }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm._f("format-message")("cancel")) +
                        "\n\t\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-link",
                    attrs: {
                      type: "submit",
                      disabled: _vm.disabled || _vm.applyDisabled
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm._f("format-message")("ok")) +
                        "\n\t\t\t\t\t"
                    )
                  ]
                )
              ],
              2
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53ef877e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53ef877e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ui/widgets/modal.vue
// module id = uUBQ
// module chunks = 3